import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Roles } from '../../../enums/roles.enum';

// Evita que un usuario autenticado acceda a la página de login
export const AuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    const userRoles = authService.getUserRoles() ?? [];
    const normalizedUserRoles = Array.isArray(userRoles) ? userRoles.map((role) => role.toUpperCase().trim()) : [];

    if (normalizedUserRoles.includes(Roles.SuperAdmin) || normalizedUserRoles.includes(Roles.Admin)) {
      router.navigate(['/admin']);
    } else if (normalizedUserRoles.includes(Roles.Representante) || normalizedUserRoles.includes(Roles.Usuario)) {
      router.navigate(['/home']);
    } else {
      router.navigate(['/dashboard']);
    }
    return false;
  } else {
    return true;
  }
};
